import React from 'react'

const FeatureCard = ({ isCompany, CardImg, cardName, cardDesc, key }) => {
  return (
    <div className=''>
      <div className='bg-white relative rounded-[10px] h-[100%] overflow-hidden'>
        {isCompany && <div className='absolute top-[15px] rotate-45 flex items-center justify-center w-[120px] h-[30px] right-[-30px] text-[13px] text-white text-center font-semibold bg-[#7059EF]'>
          Kurumsal
        </div>}
        <div className='p-[20px] '>
          <div className='flex flex-col'>
            <CardImg className={"w-[50px] h-[50px] mb-[20px] stroke-[#5E5873]"}></CardImg>
            <span className='text-[#5E5873] text-[15px] font-semibold'>{cardName}</span>
            <span className='text-[#8A92A6] text-[14px] mt-[10px] font-light' style={{ lineHeight: "20px" }}>{cardDesc}</span>
          </div>
        </div>

      </div>
    </div>
  )
}

export default FeatureCard